import { render, staticRenderFns } from "./CustomStyle.vue?vue&type=template&id=b0f362ea&scoped=true"
import script from "./CustomStyle.vue?vue&type=script&lang=js"
export * from "./CustomStyle.vue?vue&type=script&lang=js"
import style0 from "./CustomStyle.vue?vue&type=style&index=0&id=b0f362ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f362ea",
  null
  
)

export default component.exports